module.exports = __webpack_public_path__ + "static/img/evolucao-like-dislike-linha.81fef50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolucao-like-dislike-linha.png
// module id = LIr+
// module chunks = 1